// @flow
import styled from 'styled-components';

// Material
import Fab from '@material-ui/core/Fab';

export const CustomFab = styled(Fab)({
  background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  border: 0,
  borderRadius: 3,
  boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  color: 'white !important',
  height: 48,
  padding: '0 30px',
});

export const SearchFormWrapper = styled.div`
  background-color: var(--color-neutral-white);
  border-radius: var(--global-radius);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  margin-bottom: 45px;
  padding: 30px 20px 10px;
  position: relative;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;
